module.exports = __webpack_public_path__ + "media/images/flag/vn-e042c70301e64c036e206d8c355df883.jpg";